// This file is generate automatically by NPM// Don't edit this fileimport {FaqSection} from '../../../templates/flexibles/faq-section/faq-section.js'
import {FeaturesFolders} from '../../../templates/flexibles/features-folders/features-folders.js'
import {FullForm} from '../../../templates/flexibles/full-form/full-form.js'
import {Header} from '../../../templates/flexibles/header/header.js'
import {PlotPricing} from '../../../templates/flexibles/plot-pricing/plot-pricing.js'
import {PostsList} from '../../../templates/flexibles/posts-list/posts-list.js'
import {ProductFeatures} from '../../../templates/flexibles/product-features/product-features.js'
import {SliderLogo} from '../../../templates/flexibles/slider-logo/slider-logo.js'
import {SliderTestimonials} from '../../../templates/flexibles/slider-testimonials/slider-testimonials.js'
import {TableOffer} from '../../../templates/flexibles/table-offer/table-offer.js'
import {WysiwygSection} from '../../../templates/flexibles/wysiwyg-section/wysiwyg-section.js'

export let flexiblesController = {
  FaqSection: FaqSection,
  FeaturesFolders: FeaturesFolders,
  FullForm: FullForm,
  Header: Header,
  PlotPricing: PlotPricing,
  PostsList: PostsList,
  ProductFeatures: ProductFeatures,
  SliderLogo: SliderLogo,
  SliderTestimonials: SliderTestimonials,
  TableOffer: TableOffer,
  WysiwygSection: WysiwygSection
}